import { c as _c } from "react/compiler-runtime";
import Link from "next/link";
import Image from "next/image";
import { getScaledResolvedImageUri, ImageScale } from "@/helpers/image.helpers";
import UserProfileTooltipWrapper from "@/components/utils/tooltip/UserProfileTooltipWrapper";
import type { ApiProfileMin } from "@/generated/models/ApiProfileMin";
import { useGatewayImageLoadState } from "@/components/common/image/useGatewayImageLoadState";
interface NotificationHeaderProps {
  readonly author: ApiProfileMin;
  readonly children: React.ReactNode; // Content AFTER the user link (e.g. "replied • 2h")
  readonly actions?: React.ReactNode | undefined; // Follow button(s)
}
export default function NotificationHeader(t0) {
  const $ = _c(23);
  const {
    author,
    children,
    actions
  } = t0;
  const {
    activeSrc,
    isPlaceholder,
    unoptimized,
    handleError
  } = useGatewayImageLoadState(author.pfp);
  let t1;
  if ($[0] !== activeSrc || $[1] !== author.handle || $[2] !== handleError || $[3] !== isPlaceholder || $[4] !== unoptimized) {
    t1 = <div className="tw-relative tw-h-7 tw-w-7 tw-flex-shrink-0">{!isPlaceholder && activeSrc ? <Image key={`${activeSrc}-${unoptimized ? "unoptimized" : "optimized"}`} src={getScaledResolvedImageUri(activeSrc, ImageScale.W_AUTO_H_50)} alt={author.handle ?? "User profile"} fill={true} sizes="28px" unoptimized={unoptimized} onError={handleError} className="tw-flex-shrink-0 tw-rounded-md tw-bg-iron-800 tw-object-contain tw-ring-1 tw-ring-iron-700" /> : <div className="tw-h-full tw-w-full tw-flex-shrink-0 tw-rounded-md tw-bg-iron-800 tw-ring-1 tw-ring-iron-700" />}</div>;
    $[0] = activeSrc;
    $[1] = author.handle;
    $[2] = handleError;
    $[3] = isPlaceholder;
    $[4] = unoptimized;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  const t2 = author.handle ?? "";
  const t3 = `/${author.handle}`;
  let t4;
  if ($[6] !== author.handle || $[7] !== t3) {
    t4 = <Link href={t3} className="tw-text-sm tw-font-semibold tw-text-iron-50 tw-no-underline">{author.handle}</Link>;
    $[6] = author.handle;
    $[7] = t3;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== t2 || $[10] !== t4) {
    t5 = <UserProfileTooltipWrapper user={t2}>{t4}</UserProfileTooltipWrapper>;
    $[9] = t2;
    $[10] = t4;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] !== children || $[13] !== t5) {
    t6 = <div className="tw-flex tw-flex-wrap tw-items-center tw-gap-x-1">{t5}{children}</div>;
    $[12] = children;
    $[13] = t5;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  let t7;
  if ($[15] !== actions) {
    t7 = actions && <div className="tw-flex-shrink-0">{actions}</div>;
    $[15] = actions;
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  let t8;
  if ($[17] !== t6 || $[18] !== t7) {
    t8 = <div className="tw-flex tw-min-w-0 tw-flex-1 tw-flex-col tw-items-start tw-gap-y-2 min-[390px]:tw-flex-row min-[390px]:tw-items-center min-[390px]:tw-justify-between min-[390px]:tw-gap-x-2">{t6}{t7}</div>;
    $[17] = t6;
    $[18] = t7;
    $[19] = t8;
  } else {
    t8 = $[19];
  }
  let t9;
  if ($[20] !== t1 || $[21] !== t8) {
    t9 = <div className="tw-flex tw-items-start tw-gap-x-3">{t1}{t8}</div>;
    $[20] = t1;
    $[21] = t8;
    $[22] = t9;
  } else {
    t9 = $[22];
  }
  return t9;
}